










import SaveStatus from './SaveStatus.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'save-status-wrapper',
    components: { SaveStatus },
});
